<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="7" height="7" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="40" stroke-linecap="square"/>
    <rect x="12" y="12" width="7" height="7" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="40" stroke-linecap="square"/>
    <rect x="12" y="1" width="7" height="7" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="40" stroke-linecap="square"/>
    <rect x="1" y="12" width="7" height="7" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="40" stroke-linecap="square"/>
  </svg>
</template>

